export const LANDING = "/";
export const HOME = "/home";

export const SIGN_IN = "/signin";
export const SIGN_UP = "/signup";
export const BECOME_DRIVER = "/become-driver";
export const BECOME_PARTNER = "/become-partner";

export const PROFILE = "/profile";
export const ABOUT_US = "/about-us";
export const FAQ = "/FAQ";

export const RESTAURANTS_OVERVIEW = "/restaurants-overview";
export const DETAIL_PAGE = "/detail/:id";

export const CHECKOUT = "/checkout";

export const DASHBOARD_RESTAURANT_HOME = "/dashboard-restaurant";
export const DISHES = "/dashboard-restaurant/dishes";
export const DISH_EDITPAGE = "/dashboard-restaurant/edit-dish/:dishId";
export const DISH_ADD = "/dashboard-restaurant/add-dish/:restaurantId";
export const PROFILE_RESTAURANT = "/dashboard-restaurant/profile";
export const DISH_REMOVE = "/dashboard-restaurant/remove-dish/:dishId";
export const ERROR = "/error/:errorMessage"
